import { Colors } from '@ab-core/colors';
import styled from 'styled-components';

export const StyledInformationContainer = styled.div`
    color: ${Colors.gray50};
`;
